import { toLocaleDate } from "@/utils/dates";

// Invii di una quietanza o di un titolo (GET …/{id}/sendings), dal più recente.
// Valori di channel e status dall'enum del backend.
export const SENDING_OK = 0; // Inviato
const LOGGED_CHANNELS = [0, 2]; // Email e SMS passano da LisaComunica; la stampa no

const valueOf = (enumerable) =>
  enumerable && typeof enumerable === "object"
    ? Number(enumerable.value)
    : Number(enumerable);

/**
 * Righe dalla risposta: accetta la lista diretta o annidata in data/content
 * (anche paginata: data.data).
 * @param {*} body response.data
 * @returns {Array}
 */
export const sendingRows = (body) => {
  let rows = body;
  for (let i = 0; i < 3 && rows && !Array.isArray(rows); i++) {
    rows = rows.data ?? rows.content;
  }
  return Array.isArray(rows) ? rows : [];
};

/** L'invio riuscito più recente, o null. */
export const lastSuccessfulSending = (rows) =>
  rows
    .filter((row) => valueOf(row.status) === SENDING_OK && row.sent_at)
    .reduce(
      (last, row) => (!last || row.sent_at > last.sent_at ? row : last),
      null
    );

export const formatSentAt = (value) =>
  toLocaleDate(value, "DD/MM/YYYY HH:mm", "-");

/** Testo della riga sopra la tabella. */
export const lastSuccessfulLabel = (rows) => {
  const last = lastSuccessfulSending(rows);
  return last
    ? `Ultimo invio riuscito: ${formatSentAt(last.sent_at)}`
    : "Nessun invio riuscito";
};

/** Il log di LisaComunica esiste solo per email e SMS di una procedura. */
export const hasSendingLog = (row) =>
  LOGGED_CHANNELS.includes(valueOf(row.channel)) &&
  !!row.communication_procedure?.id;
